import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  VehicleRevisionConfigureParams,
  VehicleRevisionDetail,
  VehicleRevisionFindAllParams,
  VehicleRevisionListItem,
  VehicleRevisionOverdueSummary,
  VehicleRevisionRegisterParams,
  VehicleRevisionUpdateIntervalParams,
} from './type';
import { PaginatedResponse } from '@/app/common/utils/pagination/types';
import { VehicleRevisionApiService } from '../infra/api.service';

@Injectable({ providedIn: 'root', useClass: VehicleRevisionApiService })
export abstract class VehicleRevisionService {
  abstract findAll(
    filter?: VehicleRevisionFindAllParams,
  ): Observable<PaginatedResponse<VehicleRevisionListItem>>;

  abstract findByChassis(chassis: string): Observable<VehicleRevisionDetail>;

  abstract getOverdueSummary(): Observable<VehicleRevisionOverdueSummary>;

  abstract configure(
    chassis: string,
    params: VehicleRevisionConfigureParams,
  ): Observable<VehicleRevisionDetail>;

  abstract updateInterval(
    chassis: string,
    params: VehicleRevisionUpdateIntervalParams,
  ): Observable<VehicleRevisionDetail>;

  abstract registerRevision(
    chassis: string,
    params: VehicleRevisionRegisterParams,
  ): Observable<VehicleRevisionDetail>;
}
